module.exports = __webpack_public_path__ + "img/MindMapit4wallonie.5bac6e5a.jpg";